import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Helmet from "react-helmet"
import '@fortawesome/fontawesome-svg-core/styles.css'


import "./layout.css"

const Layout = ({ pageTitle, children }) => {
  const { site, header, footer } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
          description
        }
      }
      footer {
        html
      }
      header {
        html
      }
    }
  `)

  return (
    <>
      <Helmet>
        <html lang="en" />  
        <meta charSet="utf-8"/>
        <title>{`Nevada State Legislature Employment Opportunities | ${pageTitle}`}</title>
        <meta description="Find employment opportunities with the Nevada Legislature"/>
			  <meta name="viewport" content="width=device-width, initial-scale=1"/>
        <link
          rel="stylesheet"
          href="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/css/bootstrap.min.css"
          integrity="sha384-ggOyR0iXCbMQv3Xipma34MD+dH/1fQ784/j6cY/iJTQUOhcWr7x9JvoRxT2MZw1T"
          crossOrigin="anonymous"
        />
        <link href="/site/library/css/theme-backgrounds.css" rel="stylesheet" type="text/css"/>
				<link href="/site/library/css/theme-colors.css" rel="stylesheet" type="text/css"/>
				<link href="/site/library/css/theme-buttons.css" rel="stylesheet" type="text/css"/>
				<link href="/site/library/css/theme-cards.css" rel="stylesheet" type="text/css"/>
				<link href="/site/library/css/theme-borders.css" rel="stylesheet" type="text/css"/>
				<link href="/site/library/css/theme-navigation.css" rel="stylesheet" type="text/css"/>
        <script
          src="https://code.jquery.com/jquery-3.5.1.min.js"
          integrity="sha256-9/aliU8dGd2tb6OSsuzixeV4y/faTqgFtohetphbbj0="
          crossorigin="anonymous"></script>
                        <script
          src="https://stackpath.bootstrapcdn.com/bootstrap/4.3.1/js/bootstrap.min.js"
          integrity="sha384-JjSmVgyd0p3pXB1rRibZUAYoIIy6OrQ6VrjIEaFf/nJGzIxFDsf4x0xIM+B07jRM"
          crossOrigin="anonymous"
        ></script>
      </Helmet>

        <header id="header" dangerouslySetInnerHTML={{ __html: header.html }}></header>
        <main id="main-content" className="container-fluid">{children}</main>
        <footer id="footer" className="mt-5" dangerouslySetInnerHTML={{ __html: footer.html }}></footer>
        <script
          src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.7/umd/popper.min.js"
          integrity="sha384-UO2eT0CpHqdSJQ6hJty5KVphtPhzWj9WO1clHTMGa3JDZwrnQq4sF86dIHNDz0W1"
          crossOrigin="anonymous"
        ></script>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
